<template>
  <div>
    <el-container style="height: 100vh">
      <el-header><Header /></el-header>
      <el-container>
        <el-aside>
          <Sidebar class="aside-container" />
        </el-aside>
        <el-container>
          <el-main>
            <div class="main-container" :class="isCollapse === true ? 'container_collapse' : ''">
              <Main />
            </div>
          </el-main>
          <!--          <el-footer>Footer</el-footer>-->
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>
<script>
  import Sidebar from './Sidebar.vue';
  import Header from './Header.vue';
  import Main from './Main.vue';
  import { mapState } from 'vuex';
  import { setCssVar } from 'utils/theme';

  const HEADER_BG_COLOR_VAR = '--header-bg-color';
  const SIDER_TEXT_COLOR_VAR = '--sider-text-color';
  const SIDER_TEXT_ACTIVE_COLOR_VAR = '--sider-text-active-color';

  export default {
    components: {
      Sidebar,
      Header,
      Main,
    },
    computed: {
      ...mapState({
        isCollapse: (state) => state.app.isCollapse,
      }),
    },
    watch: {
      '$store.state.app.theme': {
        handler: function(val) {
          if (val === 'gourdmobi') {
            setCssVar(HEADER_BG_COLOR_VAR, '#337ab7');
            setCssVar(SIDER_TEXT_COLOR_VAR, '#337ab7');
            setCssVar(SIDER_TEXT_ACTIVE_COLOR_VAR, '#bdb7ff');
          } else if (val === 'bananamobiads') {
            setCssVar(HEADER_BG_COLOR_VAR, '#aacd99');
            setCssVar(SIDER_TEXT_COLOR_VAR, '#aacd99');
            setCssVar(SIDER_TEXT_ACTIVE_COLOR_VAR, '#47812b');
          }
        },
      },
    },
    mounted() {
      this.$store.dispatch('app/setTheme');
    },
  };
</script>
<style lang="scss" scoped>
  .main-container {
    height: 100%;
    background-color: #f0f2f5;
    -webkit-transition: margin-left 0.28s;
    transition: margin-left 0.28s;
    position: relative;
  }
  .container_collapse {
    margin-left: 64px;
  }
</style>
